import { runningClientSide } from '@benzinga/utils';

export const disableOptinMonsterCampaigns = () => {
  if (!runningClientSide() || typeof document === 'undefined') {
    return;
  }

  document.addEventListener('om.Campaign.startShow', event => {
    if (event['detail']) {
      const optinCampaign = document.querySelector('#om-' + event['detail'].Campaign.id);
      optinCampaign?.remove();
    }
  });

  document.addEventListener('om.DisplayRules.afterRun', event => {
    const eventDetail = event['detail'];
    if (eventDetail) {
      const DisplayRules = eventDetail.DisplayRules;
      if (DisplayRules) {
        DisplayRules.show = false;
      }
    }
  });
};

export const disableOptinMonsterFonts = () => {
  // Hack to disable all fonts from the Optin Monster
  document.addEventListener('om.Scripts.init', event => {
    if (event && event['detail']) {
      event['detail'].Scripts.enabled.fonts = false;
    }
  });
};
